import React from 'react';
import PropTypes from 'prop-types';
import { Alert, } from 'react-bootstrap';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../modules/Constants';
import ObjectUtils from '../../modules/ObjectUtils';
import Table from '../table/Table';

const DEFAULT_FORMATTER = value => value.header;
const DEFAULT_FILTER = () => true;
class Grid extends React.Component {
  static toModelFromList(list = [], options = {}) {
    const proto = {};
    if (list && list.length > 0) {
      const keySet = ObjectUtils.toLargestKeySet(list);
      keySet.forEach((key) => {
        proto[key] = null;
      });
      return this.toModel(proto, options);
    }
    return this.toModel(proto, options);
  }

  static toModel(proto = {}, options = {}) {
    const { headerFormatter = DEFAULT_FORMATTER, filter = DEFAULT_FILTER, } = options;
    const headers = [];
    const filteredProto = ObjectUtils.filterObject(proto, filter);

    Object.keys(filteredProto.value).forEach((header, index) => {
      headers.push({
        value: header,
        display: headerFormatter({ header, index, }),
      });
    });

    return {
      headers,
      format: (models = []) => (models
        ? models.map((model) => {
          const values = [];
          headers.forEach((header) => {
            const key = header.value;
            if (!model[key] && typeof model[key] !== 'boolean') {
              values.push('');
            } else {
              let value = model[key];
              switch (key) {
                case 'paymentDate':
                  value = new Date(value).toLocaleString();
                  break;
                case 'paymentAmount':
                  value = value?.includes('$') ? value : Number(value).toFixed(2);
                  break;
                default:
                  break;
              }
              values.push(value);
            }
          });
          return {
            value: values,
            raw: model,
          };
        })
        : []),
    };
  }

  onRowSelect(dataRow) {
    const { headers = [], onRowSelect, } = this.props;
    const row = {};
    if (onRowSelect) {
      Object.keys(dataRow).forEach((key) => {
        const header = headers.find(head => head.display === key);
        row[header.value] = dataRow[key];
      });
      onRowSelect(row);
    }
  }

  formatRows(rows = []) {
    return rows.map(row => row.value);
  }

  formatHeaders(headers = []) {
    return headers.map(header => header.display);
  }

  formatContents(props) {
    const { headers = [], rows = [], onEmptyGridMessage = EMPTY_GRID_DEFAULT_MESSAGE, } = props;
    if ((headers.length <= 0 || rows.length <= 0) && onEmptyGridMessage) {
      return (
        <Alert className="mt-2" variant="secondary">
          {onEmptyGridMessage}
        </Alert>
      );
    }
    return (
      <Table
        className="table table-sm small table-striped"
        headers={this.formatHeaders(headers)}
        rows={this.formatRows(rows)}
        onRowSelect={row => this.onRowSelect(row)}
      />
    );
  }

  render() {
    const { style, } = this.props;
    const gridStyle = {
      ...style,
    };
    return (
      <div>
        <div className="row-sm-10">
          <div className="col">
            <div className="float-end" />
            <div className="overflow-auto" style={gridStyle}>
              {this.formatContents(this.props)}
            </div>
            <div className="float-start" />
          </div>
        </div>
      </div>
    );
  }
}

Grid.defaultProps = {
  onRowSelect: () => {},
  style: {},
  headers: [],
};

Grid.propTypes = {
  onRowSelect: PropTypes.func,
  headers: PropTypes.array,
  style: PropTypes.object,
};

export default Grid;
